import React, {useMemo, useState, useEffect} from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import { setNormativeArticles, setNormativeChapters, setNormativeDocumentTree } from '../../../../redux/reducers/normative-documents-reducer';
import { useDispatch } from 'react-redux';
import TreeCheckListForUser from '../../../TreeCheckListForUser/TreeCheckListForUser';



const useStyles = makeStyles(theme => ({
    tableError: {
        borderColor: theme.palette.error.main
    }
}))


export const CheckList = (props) => {

    const {content, variable, value, setFieldValue} = props
    const dispatch = useDispatch()

    useEffect(() => {
        if (content?.normativeDocumentTree !== undefined) {
            dispatch(setNormativeDocumentTree(content.normativeDocumentTree))
            dispatch(setNormativeChapters(content.normativeChapters))
            dispatch(setNormativeArticles(content.normativeArticles))
        }
    },[])

    return (
        <div>
            <TreeCheckListForUser 
                checkListId={content.checkListId} 
                setFieldValue={setFieldValue} 
                content={content}
                value={value} 
                variable={variable}
            />
    
        </div>);
}